import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const TabsBox = styled(Box)`
  display: flex;
  justify-content: flex-end;
`

export const Buttons = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    gap: 32px;
    margin-top: 32px;
    justify-content: flex-end;

    @media (max-width: ${theme.screenSizes.laptop}) {
      width: 100%;
      flex-direction: column;
      gap: 16px;
    }
  `}
`

export const StartOfBillingBox = styled(Box)`
  ${({ theme }) => css`
    width: 455px;
    margin-bottom: 24px;
    display: flex;
    align-items: flex-end;
    gap: 24px;

    @media (max-width: ${theme.screenSizes.laptop}) {
      width: 100%;
      flex-direction: column;
    }
  `}
`
